import { Folder, X } from "lucide-react";
import { cn } from "@repo/utils";
import { Button } from "../../button/button";
import { HoverTooltip } from "../hover-tooltip";
import type { Props as InputProps } from "../input";
import { inputVariants } from "../input-variants.js";

type Props = Pick<InputProps, "variant" | "inputSize" | "className" | "disabled" | "error"> & {
  value?: string | null;
  placeholder: string;
  onClick: () => void;
  onClear: () => void;
};

export const DirectoryTrigger = ({
  value,
  placeholder,
  onClick,
  onClear,
  disabled,
  error,
  variant,
  inputSize,
  className,
}: Props) => {
  return (
    <HoverTooltip
      content={value}
      wrapperClassName="flex w-full"
      className="max-w-[min(32rem,90vw)] break-all whitespace-normal"
    >
      <div className="group relative w-full cursor-pointer" onClick={onClick}>
        <div
          className={cn(
            inputVariants({ variant: error ? "error" : variant, inputSize }),
            "flex items-center truncate pr-16 text-gray-700 select-none",
            disabled && "cursor-not-allowed bg-gray-50 opacity-50",
            className
          )}
        >
          {value ? (
            <span className="truncate text-[12px]">{value}</span>
          ) : (
            <span className="text-[12px] text-gray-400">{placeholder}</span>
          )}
        </div>
        {!disabled && (
          <div className="absolute top-1/2 right-3 flex -translate-y-1/2 items-center gap-1">
            {value && (
              <Button
                icon={<X size={14} />}
                size={"icon_sm"}
                aria-label="Clear"
                variant="ghost"
                title="Clear"
                onClick={(e) => {
                  e.stopPropagation();
                  onClear();
                }}
              ></Button>
            )}
            <Folder
              size={18}
              className="text-gray-400 transition-colors group-hover:text-gray-600"
            />
          </div>
        )}
      </div>
    </HoverTooltip>
  );
};
